<div class="modal-content">
      <div class="modal-header">
         <h5 class="modal-title" id="projectTitle">Mover projeto pra outra pasta</h5>
           <div>
             <a (click)="dismissModal()">
                <i class='bx bx-x'></i>
             </a>
          </div> 
      </div>

      <div class="col form-group" *ngIf="repositories && repositories.length > 0">
        <br>
        <select class="custom-select form-controlpage" [(ngModel)]="selectedRepository">
          <option [value]="''" disabled>Selecione a pasta</option>
          <option *ngFor="let repository of repositories" [value]="repository.id">
            {{ repository.name }}
          </option>
        </select>
      </div>
      <div class="teste" *ngIf="!repositories || repositories.length === 1">
          Não há pastas disponíveis.
      </div>
    
       

      <div class="modal-footer">
        <button type="button" class="button button-cancel" (click)="dismissModal()">Voltar</button>
        <button type="button" (click)="toSend()" [attr.data-loader]="!submitted" btnloader class="btn btn-primary">
            Enviar
        </button>
      </div>  

</div>
